export default __webpack_public_path__ + "static/media/input-arrow.b4fcb159.svg";